(function () {
  var productEl = document.querySelector('.product-page');
  if (!productEl) return;

  var productData;

  try {
    productData = JSON.parse(productEl.dataset.product);
  } catch (e) {
    console.error('[Product] Invalid product data', e);
    return;
  }

  if (!productData) return;

  const SELECTORS = {
    group: '.option-group',
    button: '[data-option-value]',
    active: '.active',
  };

  function isColorOption(name) {
    return String(name || '').toLowerCase().includes('color');
  }

  function initSwatches() {
    document.querySelectorAll(SELECTORS.group).forEach((group, index) => {
      const optionName = productData.options[index];

      if (!isColorOption(optionName)) return;

      group.querySelectorAll('[data-option-value]').forEach(btn => {
        const color = btn.dataset.optionValue;

        btn.style.backgroundColor = color;
        btn.textContent = '';
      });
    });
  }

  function getSelectedOptions() {
    const selected = [];

    document.querySelectorAll(SELECTORS.group).forEach((group, i) => {
      const active = group.querySelector(SELECTORS.active);

      if (active) {
        selected[i] = active.dataset.optionValue;
      }
    });

    return selected;
  }

  function findVariant(selected) {
    if (!productData.variants || !productData.variants.length) {
      return null;
    }

    /*
     * If the product has only one variant,
     * always use that variant.
     */
    if (productData.variants.length === 1) {
      return productData.variants[0];
    }

    return productData.variants.find(v => {
      return v.options.every((opt, i) => opt === selected[i]);
    });
  }

  function updateVariant() {
    const selected = getSelectedOptions();
    const variant = findVariant(selected);

    if (!variant) return;

    const input = document.getElementById('variant-id-input');

    if (input) {
      input.value = variant.id;
    }

    updatePrice(variant);
    updateCartButton(variant);

    if (variant.featured_media) {
      switchMedia(variant.featured_media.id);
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);

    window.history.replaceState({}, '', url.toString());

    document.dispatchEvent(
      new CustomEvent('variantChanged', {
        detail: {
          variantId: variant.id
        }
      })
    );
  }

  function updateOptionAvailability() {
    const selected = getSelectedOptions();

    document.querySelectorAll(SELECTORS.button).forEach(btn => {
      const index = Number(btn.dataset.optionIndex);
      const value = btn.dataset.optionValue;

      const test = [...selected];
      test[index] = value;

      const valid = productData.variants.some(v => {
        return v.options.every((opt, i) => {
          if (!test[i]) return true;
          return opt === test[i];
        });
      });

      btn.classList.toggle('disabled', !valid);

      btn.style.pointerEvents = valid ? 'auto' : 'none';
      btn.style.opacity = valid ? '1' : '0.4';
    });
  }

  function onOptionClick(btn) {
    if (btn.classList.contains('disabled')) return;

    const index = Number(btn.dataset.optionIndex);

    const groups = document.querySelectorAll(SELECTORS.group);
    const group = groups[index];

    if (!group) return;

    group.querySelectorAll(SELECTORS.button).forEach(b => {
      b.classList.remove('active');
    });

    btn.classList.add('active');

    const label = document.getElementById(`option-value-${index}`);

    if (label) {
      label.textContent = btn.dataset.optionValue;
    }

    updateVariant();
    updateOptionAvailability();
  }

  function initOptions() {
    document.querySelectorAll(SELECTORS.button).forEach(btn => {
      btn.addEventListener('click', () => {
        onOptionClick(btn);
      });
    });
  }

  function updatePrice(variant) {
    function formatPrice(cents) {
      if (cents === null || cents === undefined) {
        return '';
      }

      const format = window.__ornixSettings?.moneyFormat;

      if (
        window.Shopify &&
        Shopify.formatMoney &&
        format
      ) {
        return Shopify.formatMoney(cents, format);
      }

      if (format) {
        const amount = (cents / 100).toFixed(2);

        return format.replace(
          '{{amount}}',
          amount
        );
      }

      return (cents / 100).toFixed(2);
    }

    const el = document.getElementById('product-price');

    if (!el) return;

    let html =
      `<span class="price-current">${formatPrice(variant.price)}</span>`;

    if (
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    ) {
      const save =
        variant.compare_at_price - variant.price;

      html +=
        `<span class="price-compare">${formatPrice(variant.compare_at_price)}</span>`;

      html +=
        `<span class="price-badge">Save ${formatPrice(save)}</span>`;
    }

    el.innerHTML = html;
  }

  /*
   * IMPORTANT:
   *
   * Do NOT use:
   *
   *     btn.textContent = 'Add to Cart'
   *
   * because that removes:
   *
   *     <span class="loom-add-label">
   *
   * from your custom button.
   *
   * We only change the label inside the button.
   */
  function updateCartButton(variant) {
    const btn = document.getElementById('add-to-cart-btn');

    if (!btn) return;

    const label = btn.querySelector('.loom-add-label');

    if (variant && variant.available) {
      btn.disabled = false;

      if (label) {
        label.textContent = 'Add to Cart';
      }
    } else {
      btn.disabled = true;

      if (label) {
        label.textContent = 'Sold Out';
      }
    }
  }

  function switchMedia(id) {
    id = String(id);

    document.querySelectorAll('.media-item').forEach(el => {
      el.classList.toggle(
        'active',
        el.dataset.mediaId === id
      );
    });

    document.querySelectorAll('.thumb-item').forEach(el => {
      el.classList.toggle(
        'active',
        el.dataset.mediaId === id
      );
    });
  }

  function initQuantity() {
    const input =
      document.getElementById('quantity-input');

    if (!input) return;

    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });

    const minus =
      document.querySelector('.qty-minus');

    const plus =
      document.querySelector('.qty-plus');

    if (minus) {
      minus.addEventListener('click', () => {
        const current =
          Number(input.value) || 1;

        if (current > 1) {
          input.value = current - 1;
        }

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        const current =
          Number(input.value) || 1;

        input.value = current + 1;

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });
    }
  }

  function initPickup() {}

  function initAddToCart() {
    var form =
      document.getElementById('product-form');

    if (!form) return;

    form.addEventListener(
      'submit',
      async function (e) {
        var settings =
          window.__ornixSettings || {};

        var cartType =
          settings.cartType ||
          settings.cart_type ||
          'drawer';

        var btn =
          document.getElementById(
            'add-to-cart-btn'
          );

        e.preventDefault();

        /*
         * CHANGE ONLY THE INNER LABEL.
         */
        if (btn) {
          btn.disabled = true;

          const label =
            btn.querySelector(
              '.loom-add-label'
            );

          if (label) {
            label.textContent = 'Adding...';
          }
        }

        try {
          var formData =
            new FormData(form);

          var body = {
            id: formData.get('id'),
            quantity:
              Number(
                formData.get('quantity')
              ) || 1,
          };

          var sellingPlan =
            formData.get('selling_plan');

          if (sellingPlan) {
            body.selling_plan =
              sellingPlan;
          }

          var properties = {};

          formData.forEach(
            function (val, key) {
              if (
                key.startsWith(
                  'properties['
                )
              ) {
                var propKey =
                  key
                    .replace(
                      'properties[',
                      ''
                    )
                    .replace(
                      ']',
                      ''
                    );

                properties[propKey] =
                  val;
              }
            }
          );

          if (
            Object.keys(properties)
              .length > 0
          ) {
            body.properties =
              properties;
          }

          var res = await fetch(
            window.Shopify.routes.root +
              'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Accept:
                  'application/json',
              },
              body:
                JSON.stringify(body),
            }
          );

          if (!res.ok) {
            throw new Error(
              'Add to cart failed'
            );
          }

          if (
            cartType === 'page'
          ) {
            window.location.href =
              window.Shopify.routes.root +
              'cart';

            return;
          }

          var cartRes =
            await fetch(
              window.Shopify.routes.root +
                'cart.js',
              {
                headers: {
                  Accept:
                    'application/json',
                },
              }
            );

          var cart =
            await cartRes.json();

          var drawerEl =
            document.getElementById(
              'cart-drawer'
            );

          if (
            drawerEl &&
            typeof drawerEl.open ===
              'function' &&
            typeof drawerEl.refresh ===
              'function'
          ) {
            await drawerEl.refresh(
              cart
            );

            drawerEl.open();

            return;
          }

          window.location.href =
            window.Shopify.routes.root +
            'cart';

        } catch (err) {
          console.error(
            '[AddToCart]',
            err
          );

        } finally {
          var variant =
            findVariant(
              getSelectedOptions()
            );

          if (btn) {
            if (variant) {
              btn.disabled =
                !variant.available;

              const label =
                btn.querySelector(
                  '.loom-add-label'
                );

              if (label) {
                label.textContent =
                  variant.available
                    ? 'Add to Cart'
                    : 'Sold Out';
              }
            } else {
              btn.disabled = false;

              const label =
                btn.querySelector(
                  '.loom-add-label'
                );

              if (label) {
                label.textContent =
                  'Add to Cart';
              }
            }
          }
        }
      }
    );
  }

  function init() {
    initOptions();
    initSwatches();
    updateVariant();
    updateOptionAvailability();
    initQuantity();
    initPickup();
    initAddToCart();
  }

  /*
   * Run after DOM is ready.
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  /*
   * ============================
   * SIZE CHART DRAWER
   * ============================
   */

  const sizeChartTrigger =
    document.querySelector(
      '.size-chart-trigger'
    );

  const sizeChartDrawer =
    document.getElementById(
      'size-chart-modal'
    );

  const sizeChartClose =
    document.getElementById(
      'size-chart-close'
    );

  const sizeChartOverlay =
    sizeChartDrawer?.querySelector(
      '.size-chart-drawer__overlay'
    );

  if (
    sizeChartTrigger &&
    sizeChartDrawer
  ) {
    sizeChartTrigger.addEventListener(
      'click',
      () => {
        sizeChartDrawer.classList.add(
          'open'
        );

        document.body.style.overflow =
          'hidden';

        sizeChartClose?.focus();
      }
    );

    function closeSizeChart() {
      sizeChartDrawer.classList.remove(
        'open'
      );

      document.body.style.overflow =
        '';

      sizeChartTrigger.focus();
    }

    sizeChartClose?.addEventListener(
      'click',
      closeSizeChart
    );

    sizeChartOverlay?.addEventListener(
      'click',
      closeSizeChart
    );

    document.addEventListener(
      'keydown',
      e => {
        if (
          e.key === 'Escape' &&
          sizeChartDrawer.classList.contains(
            'open'
          )
        ) {
          closeSizeChart();
        }
      }
    );
  }

})();